/* eslint-disable react/no-array-index-key */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import LockedAccountForm from 'containers/LockedAccountForm'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { modalShow, modalHide } from 'actions/modals'
import { getLockedAccounts } from 'actions/accountsAndLoans'
import { deleteLockedAccount } from 'actions/lockedAccountForm'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { hasAccess } from 'utils/hasAccess'

class LockedAccounts extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    deleteLockedAccount: PropTypes.func.isRequired,
    getLockedAccounts: PropTypes.func.isRequired,
    lockedAccountForm: PropTypes.object.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    routes: PropTypes.instanceOf(Array),
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }
  componentDidMount() {
    hasAccess(this.props.currentUser, 'Accounts and Loans', this.props.history, 'RW', true)
    this.props.getLockedAccounts(this.props.currentUser.EmployeeId)
  }

  handleOpenLockedAccountForm = () => {
    this.props.modalShow('lockedAccountForm')
  }

  handleDeleteLockedAccount = (account) => {
    const formData = {
      employee_id: this.props.currentUser.EmployeeId,
      loginname: '',
      accountprefix: (account || ''),
    }
    if (account) {
      this.props.deleteLockedAccount(formData)
    }
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      routes, accountsAndLoans, currentUser, lockedAccountForm,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText="Locked account" isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              accountsAndLoans={accountsAndLoans}
              currentUser={currentUser}
              deleteLockedAccount={this.handleDeleteLockedAccount}
              lockedAccountForm={lockedAccountForm}
              openLockedAccountForm={this.handleOpenLockedAccountForm}
              setErrorMessage={this.props.setErrorMessage}
            />
            ))}
          <LockedAccountForm
            currentUser={currentUser}
            hide={this.props.modalHide}
          />
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  accountsAndLoans: state.accountsAndLoans,
  lockedAccountForm: state.lockedAccountForm,
  deleteLockedAccount: state.deleteLockedAccount,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getLockedAccounts,
  deleteLockedAccount,
  modalShow,
  modalHide,
})(LockedAccounts))



// WEBPACK FOOTER //
// ./src/containers/LockedAccounts.js